"use strict";

var _defineProperty = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSucceeded = exports.hasFailed = exports.isPending = exports.getTransactionOrigin = exports.getTransactionHref = exports.buildTransactionWithReceiptPayload = exports.buildTransactionPayload = exports.getTransactionHashFromAction = exports.getTransactionFromAction = exports.isTransactionAction = exports.buildActionRef = exports.TRANSACTION_ACTION_FLAG = void 0;

var schemas_1 = require("@dcl/schemas");

var types_1 = require("./types"); // Special flag used to determine transaction hashes to be monitored


exports.TRANSACTION_ACTION_FLAG = '_watch_tx';

function buildActionRef(transaction) {
  var actionType = transaction.actionType,
      withReceipt = transaction.withReceipt,
      payload = transaction.payload;
  var buildFunction = withReceipt ? buildTransactionWithReceiptPayload : buildTransactionPayload;
  return {
    type: actionType,
    payload: buildFunction(transaction.chainId, transaction.hash, payload)
  };
}

exports.buildActionRef = buildActionRef;

function isTransactionAction(action) {
  return !!getTransactionFromAction(action);
}

exports.isTransactionAction = isTransactionAction;

function getTransactionFromAction(action) {
  return action.payload && action.payload[exports.TRANSACTION_ACTION_FLAG];
}

exports.getTransactionFromAction = getTransactionFromAction;

function getTransactionHashFromAction(action) {
  return getTransactionFromAction(action).hash;
}

exports.getTransactionHashFromAction = getTransactionHashFromAction;

function buildTransactionPayload(chainId, hash) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _defineProperty({}, exports.TRANSACTION_ACTION_FLAG, {
    chainId: chainId,
    hash: hash,
    payload: payload
  });
}

exports.buildTransactionPayload = buildTransactionPayload;

function buildTransactionWithReceiptPayload(chainId, hash) {
  var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var txPayload = buildTransactionPayload(chainId, hash, payload);
  txPayload[exports.TRANSACTION_ACTION_FLAG].withReceipt = true;
  return txPayload;
}

exports.buildTransactionWithReceiptPayload = buildTransactionWithReceiptPayload;

function getTransactionHref(_ref2, network) {
  var txHash = _ref2.txHash,
      address = _ref2.address,
      blockNumber = _ref2.blockNumber;
  var pathname = address ? "/address/".concat(address) : blockNumber ? "/block/".concat(blockNumber) : "/tx/".concat(txHash);
  return "".concat(getTransactionOrigin(network)).concat(pathname);
}

exports.getTransactionHref = getTransactionHref;

function getTransactionOrigin() {
  var chainId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : schemas_1.ChainId.ETHEREUM_MAINNET;

  switch (chainId) {
    case schemas_1.ChainId.ETHEREUM_ROPSTEN:
      return 'https://ropsten.etherscan.io';

    case schemas_1.ChainId.ETHEREUM_RINKEBY:
      return 'https://rinkeby.etherscan.io';

    case schemas_1.ChainId.ETHEREUM_GOERLI:
      return 'https://goerli.etherscan.io';

    case schemas_1.ChainId.MATIC_MAINNET:
      return 'https://explorer-mainnet.maticvigil.com';

    case schemas_1.ChainId.MATIC_MUMBAI:
      return 'https://explorer-mumbai.maticvigil.com';

    default:
      return 'https://etherscan.io';
  }
}

exports.getTransactionOrigin = getTransactionOrigin;

function isPending(status) {
  return !types_1.FINISHED_STATUS.includes(status);
}

exports.isPending = isPending;

function hasFailed(status) {
  return types_1.FAILED_STATUS.includes(status);
}

exports.hasFailed = hasFailed;

function hasSucceeded(status) {
  return types_1.SUCCESS_STATUS.includes(status);
}

exports.hasSucceeded = hasSucceeded;